import { forRails } from 'components/for-rails'
import { SkillsDrawer } from 'components/skills-drawer'
import { TeamSkillsPage } from '../src/pages/team-skills-page'
import { registerComponents } from '../src/utils/react/registry'

registerComponents({
  TeamSkillsPage: forRails(TeamSkillsPage),
  SkillsDrawer: forRails(SkillsDrawer),
})
